/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4; // Set the maximum number of products to 4
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof (recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
          console.log('Recently viewed IDs:', window.recentlyViewedIds); // Debugging log

          // Remove all products starting with 'your-customized-product'
          window.recentlyViewedIds = window.recentlyViewedIds.filter(id => !id.startsWith('your-customized-product'));

          // Update localStorage without 'your-customized-product'
          window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      // Remove the last 'OR ' from the products string
      this.products = this.products.slice(0, -4);

      this.url = this.url + encodeURIComponent(this.products);
      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Log the fetched products for inspection
            const productItems = recommendations.querySelectorAll('.product-item');
            productItems.forEach(productItem => {
              console.log(productItem.innerHTML); // Debugging log to inspect product structure

              const productTitle = productItem.querySelector('.product-title'); // Adjust selector for the title
              if (productTitle && productTitle.textContent.trim().startsWith("Your Customized Product")) {
                productItem.remove(); // Remove the item from the DOM
              }
            });

            // Insert the filtered products into the container
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
